import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { temporaryPasswordGuard } from './guards/temporary-password.guard';
import { unauthGuard } from './guards/unauth.guard';
import { UnsavedChangesGuard } from './guards/unsaved-changes.guard';
import { STEUERN_ROUTES } from './pages/steuern/steuern.routes';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: 'login',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadComponent: () => import('./pages/auth/auth.page').then(m => m.AuthPage),
    canActivate: [unauthGuard]
  },
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.page').then((m) => m.HomePage),
    canActivate: [authGuard],
  },
  {
    path: 'portfolio-overview',
    loadComponent: () => import('./pages/portfolio-overview/portfolio-overview.page').then(m => m.PortfolioOverviewPage),
    canActivate: [authGuard],
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./pages/reset-password/reset-password.page').then(m => m.ResetPasswordPage),
    canActivate: [unauthGuard]
  },
  {
    path: 'change-temporary-password',
    loadComponent: () => import('./pages/change-temporary-password/change-temporary-password.page').then( m => m.ChangeTemporaryPasswordPage),
    canActivate: [temporaryPasswordGuard],
  },
  {
    path: 'setup-totp',
    loadComponent: () => import('./pages/setup-totp/setup-totp.page').then( m => m.SetupTotpPage),
    canActivate: [authGuard],
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./forgot-password/forgot-password.page').then( m => m.ForgotPasswordPage),
    canActivate: [unauthGuard]
  },
  {
    path: 'docu-hub',
    loadComponent: () => import('./pages/docu-hub/docu-hub.page').then( m => m.DocuHubPage),
    canActivate: [authGuard],
  },
  {
    path: 'docu-hub/category/:category',
    loadComponent: () => import('./pages/docu-hub-category/docu-hub-category.page').then( m => m.DocuHubCategoryPage),
    canActivate: [authGuard],
  },
  {
    path: 'docu-hub/category/:category/:product',
    loadComponent: () => import('./pages/docu-hub-documents/docu-hub-documents.page').then( m => m.DocuHubDocumentsPage),
    canActivate: [authGuard],
  },
  {
    path: 'docu-hub/all-categories',
    loadComponent: () => import('./pages/docu-hub/all-categories/all-categories.page').then( m => m.AllCategoriesPage),
    canActivate: [authGuard],
  },
  {
    path: 'docu-hub/:id',
    loadComponent: () => import('./pages/docu-hub-detail/docu-hub-detail.page').then( m => m.DocuHubDetailPage),
    canActivate: [authGuard],
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: 'profile',
    loadComponent: () => import('./pages/profile/profile.page').then( m => m.ProfilePage),
    canActivate: [authGuard],
  },
  {
    path: 'settings/change-password',
    loadComponent: () => import('./pages/profile/change-password/change-password.page').then( m => m.ChangePasswordPage),
    canActivate: [authGuard],
  },
  {
    path: 'settings/security-options',
    loadComponent: () => import('./pages/profile/security-options/security-options.page').then( m => m.SecurityOptionsPage),
    canActivate: [authGuard],
  },
  {
    path: 'offers',
    loadComponent: () => import('./pages/offers/offers.page').then( m => m.OffersPage),
    canActivate: [authGuard],
  },
  {
    path: 'smzhub',
    loadComponent: () => import('./pages/smzhub/smzhub.page').then( m => m.SmzhubPage),
    canActivate: [authGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard.page').then( m => m.DashboardPage),
    canActivate: [authGuard],
  },
  {
    path: 'markets',
    loadComponent: () => import('./pages/markets/markets.page').then( m => m.MarketsPage),
    canActivate: [authGuard],
  },
  {
    path: 'markets/:id',
    loadComponent: () => import('./pages/markets-detail/markets-detail.page').then( m => m.MarketsDetailPage),
    canActivate: [authGuard],
  },
  {
    path: 'watchlist',
    loadComponent: () => import('./pages/watchlist/watchlist.page').then( m => m.WatchlistPage),
    canActivate: [authGuard],
  },
  {
    path: 'faq',
    loadComponent: () => import('./pages/faq/faq.page').then((m) => m.FaqPage),
    canActivate: [authGuard],
  },
  {
    path: 'rechner',
    loadComponent: () => import('./pages/rechner/rechner.page').then( m => m.RechnerPage),
    canActivate: [authGuard],
  },
  {
    path: 'sparrechner',
    loadComponent: () => import('./pages/sparrechner/sparrechner.page').then( m => m.SparrechnerPage),
    canActivate: [authGuard],
  },
  {
    path: 'wohnen-and-tragbarkeit',
    loadComponent: () =>
      import('./pages/wohnen-und-tragbarkeit/wohnen-und-tragbarkeit.page').then(
        (m) => m.WohnenUndTragbarkeitPage,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'budget',
    loadComponent: () =>
      import('./pages/budget/budget.page').then((m) => m.BudgetPage),
    canActivate: [authGuard],
  },
  {
    path: 'request-offer-demo',
    loadComponent: () =>
      import('./pages/request-offer-demo/request-offer-demo.page').then(
        (m) => m.RequestOfferDemoPage,
      ),
    canActivate: [authGuard],
  },
  ...STEUERN_ROUTES,
];
